import React from 'react';
import QRCode from 'react-qr-code';
import logo from '../pages/logo.png';
import './PaymentReceipt.css';

const PaymentReceipt = ({ receipt, onClose }) => {
    if (!receipt) return null;

    const {
        receiptId = 'N/A',
        studentName = 'N/A',
        regNo = 'N/A',
        className = 'N/A',
        session = 'N/A',
        term = 'N/A',
        amount: baseAmount = 0,
        extraCharge = 0,
        vat = 0,
        flutterwaveFee = 0,
        supportFee = 0,
        totalAmount = 0,
        feeType = 'N/A',
        paymentMethod = 'N/A',
        transactionId = 'N/A',
        date,
        cashierName = 'Cashier',
        status = 'pending',
        schoolName = 'School Name',
        schoolAddress = 'School Address',
        schoolPhone = '',
        schoolWebsite = ''
    } = receipt;

    const handlePrint = () => {
        window.print();
    };

    const getFeeDescription = (fee) => {
        const feeStr = String(fee || '');
        const descriptions = {
            school_fees: "SCHOOL FEES PAYMENT",
            acceptance_fee: "ACCEPTANCE FEE",
            examination_fee: "EXAMINATION FEE",
        };
        return descriptions[feeStr] || feeStr.replace('_', ' ').toUpperCase() || "PAYMENT";
    };

    const qrData = JSON.stringify({
        receiptNo: receiptId,
        studentName,
        amount: totalAmount,
        date: date || new Date().toISOString(),
    });

    const displayDate = date ? new Date(date).toLocaleString('en-NG') : 'N/A';

    return (
        <div className="payment-receipt-container">
            <div className="receipt-controls">
                <button onClick={onClose} className="close-btn print:hidden">Close</button>
                <button onClick={handlePrint} className="print-btn print:hidden">
                    <i className="fas fa-print"></i> Print Receipt
                </button>
            </div>

            <div className="receipt-document">
                <div className="receipt-header">
                    <div className="logo-section">
                        <img src={logo} alt={`${schoolName} Logo`} className="school-logo" />
                    </div>
                    <div className="school-info">
                        <h1>{String(schoolName)}</h1>
                        <h2>{String(schoolAddress)}</h2>
                        <p className="contact">{String(schoolPhone)} | {String(schoolWebsite)}</p>
                    </div>
                    <div className="receipt-title">
                        <h3>OFFICIAL PAYMENT RECEIPT</h3>
                    </div>
                </div>

                <div className="receipt-details">
                    <div className="detail-row">
                        <div><strong>Receipt No:</strong> {String(receiptId)}</div>
                        <div><strong>Date:</strong> {displayDate}</div>
                        <div><strong>Transaction ID:</strong> {String(transactionId)}</div>
                        <div><strong>Status:</strong> <span className={`status-${String(status).toLowerCase()}`}>{String(status)}</span></div>
                    </div>

                    <div className="section-divider">STUDENT INFORMATION</div>
                    <div className="student-info-grid">
                        <div className="info-item"><span className="label">Name:</span><span className="value">{String(studentName)}</span></div>
                        <div className="info-item"><span className="label">Registration No:</span><span className="value">{String(regNo)}</span></div>
                        <div className="info-item"><span className="label">Class:</span><span className="value">{String(className)}</span></div>
                        <div className="info-item"><span className="label">Session:</span><span className="value">{String(session)} - {String(term)} Term</span></div>
                    </div>

                    <div className="section-divider">PAYMENT DETAILS</div>
                    <table className="payment-table">
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th>Amount (₦)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{getFeeDescription(feeType)}</td>
                                <td className="amount">{Number(baseAmount).toLocaleString()}</td>
                            </tr>
                             <tr>
                                <td>Extra Charge</td>
                                <td className="amount">{Number(extraCharge).toLocaleString()}</td>
                            </tr>
                            <tr>
                                <td>VAT (7.5%)</td>
                                <td className="amount">{Number(vat).toLocaleString()}</td>
                            </tr>
                            <tr>
                                <td>Flutterwave Fee</td>
                                <td className="amount">{Number(flutterwaveFee).toLocaleString()}</td>
                            </tr>
                            {supportFee > 0 && (
                                <tr>
                                    <td>Support Fee</td>
                                    <td className="amount">{Number(supportFee).toLocaleString()}</td>
                                </tr>
                            )}
                            <tr className="total-row">
                                <td><strong>TOTAL AMOUNT PAID</strong></td>
                                <td className="total-amount"><strong>₦{Number(totalAmount).toLocaleString()}</strong></td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="payment-method">
                        <p><strong>Payment Method:</strong> {String(paymentMethod)}</p>
                    </div>

                    <div className="verification-section">
                        <div className="qr-code-container">
                             <QRCode value={qrData} size={100} level="H" />
                        </div>
                    </div>

                    <div className="signature-section">
                        <div className="signature">
                            <div className="sign-line"></div>
                            <p>Cashier's Signature</p>
                            <p className="signature-name">{cashierName}</p>
                        </div>
                         <div className="stamp">
                            <div className={`stamp-circle ${String(status).toLowerCase()}`}>
                                <span>{status === 'successful' ? 'PAID' : String(status).toUpperCase()}</span>
                            </div>
                        </div>
                    </div>

                    <div className="final-message">
                        <p><strong>THANK YOU FOR YOUR PAYMENT</strong></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentReceipt;
